import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { PrintHelpers } from '../../../components'
import {Label} from "../../../components/prints/utils";
const borderStyle = { border: '1px solid #424242', paddingTop: '10px' }
export const IPhone14SeriesDisclaimerForm = ({
  ticket
}) => {
  const { organization, device, customer} = ticket

  return (
    <ReactBootstrap.Row style={{fontSize:"20px",lineHeight:"2rem"}} className="p-2 print_zone">
      <ReactBootstrap.Row className="pl-5 pr-5">
        <ReactBootstrap.Col style={borderStyle} xs={12}>
          <PrintHelpers.Header
            legend="Iphone Cross Border Disclaimer"
            organization={organization}
          />
        </ReactBootstrap.Col>
<ReactBootstrap.Row className="ms-0 me-5" style={borderStyle}>
         <ReactBootstrap.Col className="printsection" xs={12}>
            <p style={{ lineHeight: '25px' }}>
              Mr./Mrs./Miss
              <strong className="ps-2 pe-2">
                {customer.first_name} {customer.last_name}
              </strong> ("Customer")
             has submitted device model
              <strong className="ps-2 pe-2">
                <PrintHelpers.Strong value={device.product_name} />
              </strong>
              Serial No.
              <strong className="ps-2 pe-2">
               <PrintHelpers.Strong value={device.serial_number} />
              </strong>
             for service
with <strong> {organization.name} &nbsp; </strong>
            </p>


          </ReactBootstrap.Col>


        <ReactBootstrap.Col xs={12}>


    <p>Customer is hereby advised that any device purchased abroad and brought in for service, specifically the Foreign Device, may be
replaced with a device with specs and frequency configuration compliant with local regulations and technical requirements, which
may differ from those of the Foreign Device. By replacing a Foreign Device with a local device, Customer understands that said
replacement model may or may not work, or may present limitations, in Customer’s country of origin/use; this may result in
Foreign Device functional limitations with wireless service providers in country of origin, caused by the variation in specs and
frequency configurations.</p>
    <p>Upon agreeing to replace the Foreign Device with a local one, Customer releases Apple Authorized Service Provider, Apple and
its subsidiaries from any claim or liability related to any device malfunction in the country in which the Foreign Device was
purchased, and Customer further accepts they may not request a replacement of the local device as a consequence of that here
       disclaimed, whether locally or in any other country.</p>
    <p>Customer signs below in acknowledgement and understanding of the foregoing.</p>
            </ReactBootstrap.Col>

         <ReactBootstrap.Col className={"text-end"} xs={12}>
          <PrintHelpers.Strong value={organization.name}/>
        </ReactBootstrap.Col>


</ReactBootstrap.Row>
           <ReactBootstrap.Col style={borderStyle}  xs={12}>
                   <PrintHelpers.TimeStamp
            label="Data and Time"
            value={ticket.iphone14_disclaimer_signature_timestamp}
          />
                <p>
        <Label className="clearfix" value={'Place'} />
        {ticket.organization.city}
      </p>

            </ReactBootstrap.Col>


        <ReactBootstrap.Col style={borderStyle} className="text-left" xs={6}>
          <PrintHelpers.Signature signature={ticket.created_by_signature} />
          <PrintHelpers.InlineText value={ticket.created_by} />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} className="text-end" xs={6}>

          <PrintHelpers.InlineText value={'Customer Signature'} />
          <PrintHelpers.Signature signature={ticket.customer_iphone14_disclaimer_signature_s3_path} />

                 <PrintHelpers.InlineText value={`${customer.first_name} ${customer.last_name}`} />

        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
    </ReactBootstrap.Row>
  )
}
